import React from 'react';
import randomstring from 'uuid/v4';
import { findItem } from '../../../../functions/forms';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import { types, getType } from '../../../../const/types.task';

const getOperator = (type, style, catalog, intl) => {
    switch (getType(type, style)) {
        case types.boolean:
            return [
                <option key={randomstring()} value={10}>
                    {intl.formatMessage({ id: 'checks_visible' })}
                </option>,
                <option key={randomstring()} value={11}>
                    {intl.formatMessage({ id: 'checks_no_visible' })}
                </option>,
                <option key={randomstring()} value={0}>
                    {intl.formatMessage({ id: 'checks_filled' })}
                </option>,
                <option key={randomstring()} value={1}>
                    {intl.formatMessage({ id: 'checks_no_filled' })}
                </option>,
                <option key={randomstring()} value={2}>
                    {intl.formatMessage({ id: 'checks_equal_yes' })}
                </option>,
                <option key={randomstring()} value={3}>
                    {intl.formatMessage({ id: 'checks_equal_no' })}
                </option>,
            ];
        case types.action:
            return [
                <option key={randomstring()} value={10}>
                    {intl.formatMessage({ id: 'checks_visible' })}
                </option>,
                <option key={randomstring()} value={11}>
                    {intl.formatMessage({ id: 'checks_no_visible' })}
                </option>,
                <option key={randomstring()} value={0}>
                    {intl.formatMessage({ id: 'checks_filled' })}
                </option>,
                <option key={randomstring()} value={1}>
                    {intl.formatMessage({ id: 'checks_no_filled' })}
                </option>,
                <option key={randomstring()} value={4}>
                    {intl.formatMessage({ id: 'checks_filled_comment' })}
                </option>,
                <option key={randomstring()} value={2}>
                    {intl.formatMessage({ id: 'checks_equal_yes' })}
                </option>,
                <option key={randomstring()} value={3}>
                    {intl.formatMessage({ id: 'checks_equal_no' })}
                </option>,
            ];
        case types.date:
            return [
                <option key={randomstring()} value={10}>
                    {intl.formatMessage({ id: 'checks_visible' })}
                </option>,
                <option key={randomstring()} value={11}>
                    {intl.formatMessage({ id: 'checks_no_visible' })}
                </option>,
                <option key={randomstring()} value={0}>
                    {intl.formatMessage({ id: 'checks_filled' })}
                </option>,
                <option key={randomstring()} value={1}>
                    {intl.formatMessage({ id: 'checks_no_filled' })}
                </option>,
                <option key={randomstring()} value={5}>
                    {intl.formatMessage({ id: 'checks_on_range' })}
                </option>,
                <option key={randomstring()} value={6}>
                    {intl.formatMessage({ id: 'checks_out_range' })}
                </option>,
            ];
        case types.datetime:
            return [
                <option key={randomstring()} value={10}>
                    {intl.formatMessage({ id: 'checks_visible' })}
                </option>,
                <option key={randomstring()} value={11}>
                    {intl.formatMessage({ id: 'checks_no_visible' })}
                </option>,
                <option key={randomstring()} value={0}>
                    {intl.formatMessage({ id: 'checks_filled' })}
                </option>,
                <option key={randomstring()} value={1}>
                    {intl.formatMessage({ id: 'checks_no_filled' })}
                </option>,
                <option key={randomstring()} value={5}>
                    {intl.formatMessage({ id: 'checks_on_range' })}
                </option>,
                <option key={randomstring()} value={6}>
                    {intl.formatMessage({ id: 'checks_out_range' })}
                </option>,
            ];
        case types.time:
            return [
                <option key={randomstring()} value={10}>
                    {intl.formatMessage({ id: 'checks_visible' })}
                </option>,
                <option key={randomstring()} value={11}>
                    {intl.formatMessage({ id: 'checks_no_visible' })}
                </option>,
                <option key={randomstring()} value={0}>
                    {intl.formatMessage({ id: 'checks_filled' })}
                </option>,
                <option key={randomstring()} value={1}>
                    {intl.formatMessage({ id: 'checks_no_filled' })}
                </option>,
            ];
        case types.signature:
        case types.text:
        case types.file:
        case types.photo:
        case types.video:
        case types.local:
            return [
                <option key={randomstring()} value={10}>
                    {intl.formatMessage({ id: 'checks_visible' })}
                </option>,
                <option key={randomstring()} value={11}>
                    {intl.formatMessage({ id: 'checks_no_visible' })}
                </option>,
                <option key={randomstring()} value={0}>
                    {intl.formatMessage({ id: 'checks_filled' })}
                </option>,
                <option key={randomstring()} value={1}>
                    {intl.formatMessage({ id: 'checks_no_filled' })}
                </option>,
            ];
        case types.options:
            return [
                <option key={randomstring()} value={10}>
                    {intl.formatMessage({ id: 'checks_visible' })}
                </option>,
                <option key={randomstring()} value={11}>
                    {intl.formatMessage({ id: 'checks_no_visible' })}
                </option>,
                <option key={randomstring()} value={0}>
                    {intl.formatMessage({ id: 'checks_filled' })}
                </option>,
                <option key={randomstring()} value={1}>
                    {intl.formatMessage({ id: 'checks_no_filled' })}
                </option>,
                <option key={randomstring()} value={9}>
                    {intl.formatMessage({ id: 'checks_selected_option' })}
                </option>,
            ];
        case types.multioption:
            return [
                <option key={randomstring()} value={10}>
                    {intl.formatMessage({ id: 'checks_visible' })}
                </option>,
                <option key={randomstring()} value={11}>
                    {intl.formatMessage({ id: 'checks_no_visible' })}
                </option>,
                <option key={randomstring()} value={0}>
                    {intl.formatMessage({ id: 'checks_filled' })}
                </option>,
                <option key={randomstring()} value={1}>
                    {intl.formatMessage({ id: 'checks_no_filled' })}
                </option>,
                <option key={randomstring()} value={7}>
                    {intl.formatMessage({ id: 'checks_multioption_selected' })}
                </option>,
                <option key={randomstring()} value={9}>
                    {intl.formatMessage({ id: 'checks_selected_option' })}
                </option>,
            ];
        case types.number:
        case types.real:
            return [
                <option key={randomstring()} value={10}>
                    {intl.formatMessage({ id: 'checks_visible' })}
                </option>,
                <option key={randomstring()} value={11}>
                    {intl.formatMessage({ id: 'checks_no_visible' })}
                </option>,
                <option key={randomstring()} value={0}>
                    {intl.formatMessage({ id: 'checks_filled' })}
                </option>,
                <option key={randomstring()} value={1}>
                    {intl.formatMessage({ id: 'checks_no_filled' })}
                </option>,
                <option key={randomstring()} value={5}>
                    {intl.formatMessage({ id: 'checks_on_range' })}
                </option>,
                <option key={randomstring()} value={6}>
                    {intl.formatMessage({ id: 'checks_out_range' })}
                </option>,
            ];
        case types.temp:
            const commentTemp = catalog ?
                <option key={randomstring()} value={12}>
                    {intl.formatMessage({ id: 'checks_selected_option' })}
                </option>
                :
                null;
            return [
                <option key={randomstring()} value={10}>
                    {intl.formatMessage({ id: 'checks_visible' })}
                </option>,
                <option key={randomstring()} value={11}>
                    {intl.formatMessage({ id: 'checks_no_visible' })}
                </option>,
                <option key={randomstring()} value={0}>
                    {intl.formatMessage({ id: 'checks_filled' })}
                </option>,
                <option key={randomstring()} value={1}>
                    {intl.formatMessage({ id: 'checks_no_filled' })}
                </option>,
                commentTemp,
                <option key={randomstring()} value={4}>
                    {intl.formatMessage({ id: 'checks_filled_comment' })}
                </option>,
                <option key={randomstring()} value={5}>
                    {intl.formatMessage({ id: 'checks_on_range' })}
                </option>,
                <option key={randomstring()} value={6}>
                    {intl.formatMessage({ id: 'checks_out_range' })}
                </option>,
            ];
        case types.auto:
            const comment = catalog ?
                <option key={randomstring()} value={12}>
                    {intl.formatMessage({ id: 'checks_selected_option' })}
                </option>
                :
                null;
            return [
                <option key={randomstring()} value={10}>
                    {intl.formatMessage({ id: 'checks_visible' })}
                </option>,
                <option key={randomstring()} value={11}>
                    {intl.formatMessage({ id: 'checks_no_visible' })}
                </option>,
                <option key={randomstring()} value={0}>
                    {intl.formatMessage({ id: 'checks_filled' })}
                </option>,
                <option key={randomstring()} value={1}>
                    {intl.formatMessage({ id: 'checks_no_filled' })}
                </option>,
                comment,
                <option key={randomstring()} value={4}>
                    {intl.formatMessage({ id: 'checks_filled_comment' })}
                </option>,
                <option key={randomstring()} value={5}>
                    {intl.formatMessage({ id: 'checks_on_range' })}
                </option>,
                <option key={randomstring()} value={6}>
                    {intl.formatMessage({ id: 'checks_out_range' })}
                </option>,
                <option key={randomstring()} value={8}>
                    {intl.formatMessage({ id: 'checks_temp_modified' })}
                </option>,
            ];
        default:
            return [<option key={randomstring()} value={10}>
                {intl.formatMessage({ id: 'checks_visible' })}
            </option>,
            <option key={randomstring()} value={11}>
                {intl.formatMessage({ id: 'checks_no_visible' })}
            </option>];
    }
};

class Conditions extends React.Component {
    state = {
        condicion: undefined,
        options: [],
    };

    static getDerivedStateFromProps(props, state) {
        const { campo, options, intl } = props;
        if (campo !== state.condicion) {
            state.condicion = campo;
            state.options = campo.parametros && campo.parametros.campo && campo.parametros.campo.catalogo
                ? options.catalogo[campo.parametros.campo.catalogo]
                : campo.parametros && campo.parametros.campo && campo.parametros.campo.entidad
                    ? options.entidad[campo.parametros.campo.entidad]
                    : [];
            state.types = campo.parametros && campo.parametros.campo
                ? getOperator(
                    campo.parametros.campo.tipo,
                    campo.parametros.campo.estilo,
                    campo.parametros.campo.catalogo,
                    intl,
                )
                :
                [<option key={randomstring()} value={100}>
                    {intl.formatMessage({ id: 'checks_condition_instance_outrange' })}
                </option>,
                <option key={randomstring()} value={101}>
                    {intl.formatMessage({ id: 'checks_condition_instance_onrange' })}
                </option>,
                <option key={randomstring()} value={102}>
                    {intl.formatMessage({ id: 'checks_if_alert_type_2' })}
                </option>]

            return state;
        }
        return null;
    }

    isOk = () => {
        const { condicion } = this.state;
        return condicion.tipo !== undefined &&
            condicion.parametros &&
            (condicion.tipo.toString() === "100" || condicion.tipo.toString() === "101" || condicion.tipo.toString() === "102" || condicion.parametros.campo) &&
            ((condicion.tipo.toString() !== "9" && condicion.tipo.toString() !== "12") || condicion.parametros.valor)
            ;
    }

    render() {
        const { condicion, options, types } = this.state;
        const { intl } = this.props;
        const background = this.isOk() ? 'bg_white' : 'bg_ligth_lipstick_20';
        const optionSelected = !!condicion.tipo && (condicion.tipo.toString() === '9' || condicion.tipo.toString() === '12');
        const campo = condicion && condicion.parametros && condicion.parametros.campo ? findItem(this.props.manage_form.tabs, condicion.parametros.campo.codigo) : undefined;

        return (
            <Card className={'product_card cardRemoved ' + background}>
                <CardContent>
                    <Grid container justify="center" className={'flex_grow_1'}>
                        <Grid item xs={3} className="">
                            <div className="barlow_regular_small c_slate_grey margin_right_18 text_align_right ">
                                {intl.formatMessage({ id: 'checks_if_title' })}
                            </div>
                        </Grid>
                        <Grid item xs={9} className="">
                            <div className="flex_full_column">
                                <div className="flex_auto_row margin_bottom_12">
                                    {condicion.parametros.campo && condicion.parametros.campo.nombre && (
                                        <div
                                            className={
                                                'flex_full_row align_center padding_bottom_12 shadow_down_only'
                                            }
                                        >
                                            <div
                                                className={
                                                    'display_flex heigth100 margin_right_6 center '
                                                }
                                            >
                                                {this.props.icon}
                                            </div>
                                            <div
                                                className={
                                                    'flex_full_row barlow_regular_textwrap c_slate text_align_left text_wrap upper'
                                                }
                                                dangerouslySetInnerHTML={{
                                                    __html: campo.nombre.toUpperCase(),
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                                <div className="flex_auto_row margin_bottom_12">
                                    <FormControl
                                        required
                                        className={'flex_full width100 barlow_italic c_slate'}
                                    >
                                        <InputLabel htmlFor="age-native-simple">
                                            {intl.formatMessage({ id: 'selectaoption' })}
                                        </InputLabel>
                                        <Select
                                            native
                                            value={condicion.tipo}
                                            onChange={(event) =>
                                                this.props.handleChangeCondition(
                                                    'tipo',
                                                    this.props.index,
                                                    event.target.value,
                                                )
                                            }
                                        >
                                            <option key={randomstring()} value={undefined} />
                                            {types.map((e) => e)}
                                        </Select>
                                    </FormControl>
                                </div>
                                {optionSelected &&
                                    <div className="flex_auto_row margin_bottom_12">
                                        <FormControl
                                            required
                                            className={'flex_full width100 barlow_italic c_slate'}
                                        >
                                            <InputLabel htmlFor="age-native-simple">
                                                {intl.formatMessage({ id: 'selectaoption' })}
                                            </InputLabel>
                                            <Select
                                                native
                                                value={condicion.parametros.valor}
                                                onChange={(event) =>
                                                    this.props.handleChangeCondition(
                                                        'parametros',
                                                        this.props.index,
                                                        event.target.value,
                                                        'valor'
                                                    )
                                                }
                                            >
                                                <option key={randomstring()} value={undefined} />
                                                {options && options.length > 0 &&
                                                    options.map((e) => (
                                                        <option key={randomstring()} value={e.id}>
                                                            {e.nombre}
                                                        </option>
                                                    ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                }
                            </div>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        );
    }
}

export default Conditions;



// WEBPACK FOOTER //
// ./src/components/complex/manage/checks/Condition.js